<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <div class="title-row">
            <h1>Conversazione Tecnica</h1>
            <div class="title-actions">
              <button
                class="icon-button"
                :class="{ 'icon-button--flagged': isFlagged }"
                @click="toggleTicketFlag"
                :title="isFlagged ? 'Rimuovi evidenza' : 'Metti in evidenza'"
                :aria-label="isFlagged ? 'Rimuovi evidenza ticket' : 'Metti in evidenza ticket'"
              >
                <span class="material-icons">{{ isFlagged ? 'bookmark' : 'bookmark_border' }}</span>
              </button>
              <button
                class="icon-button icon-button--order"
                :class="`icon-button--order-${orderBadgeClass}`"
                @click="handleOpenOrderModal"
                title="Ultimo ordine"
                aria-label="Mostra ultimo ordine"
              >
                <span class="material-icons" aria-hidden="true">receipt_long</span>
              </button>
              <button class="icon-button staff-button-neutral" @click="viewUserDetails(user.uid)" title="Vedi utente">
                <span class="material-icons">visibility</span>
              </button>
              <button @click="showModal = true" class="icon-button staff-button-positive" title="Aggiungi Promemoria">
                <span class="material-icons">alarm_add</span>
              </button>
            </div>
          </div>

          <div class="summary-grid">
            <div class="summary-item">
              <span class="summary-label">Email</span>
              <span class="summary-value">{{ user.email || '—' }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Nome e cognome</span>
              <span class="summary-value">{{ [user.name, user.surname].filter(Boolean).join(' ') || '—' }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Studio</span>
              <span class="summary-value">{{ user.studio || '—' }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Stato ticket</span>
              <span class="summary-value">{{ ticketStatus || '—' }}</span>
            </div>
          </div>
        </div>

        <p v-if="ticketStatus === 'Completato'" class="completed-text">Ticket Completato, rispondendo, questo ticket verrà riaperto</p>

        <!-- Conversazioni -->
        <ul class="ticket-container" ref="ticketContainer">
          <li v-for="(item, index) in mergedConversations"
              :key="item.messageKey || item.id || item.fileUrl || index"
              :class="{'user-message': item.type === 'Richiesta', 'trainer-message': item.type === 'Trainer'}"
              class="message-row">
            <!-- Mostra messaggi -->
            <div v-if="item.type" class="message-info">
              <strong>{{ item.type }} ({{ formatDate(item.timestamp) }}):</strong>
              <button
                v-if="canDeleteMessages && item.source === 'conversation' && (item.type === 'Trainer' || item.type === 'Notifica')"
                @click="deleteMessage(item)"
                class="delete-button staff-button-danger"
              >
                Elimina
              </button>
            </div>
            <div v-if="item.content" class="message-content" v-html="sanitizeMessageContent(item.content)"></div>

            <!-- Mostra i documenti nella conversazione -->
            <div v-if="item.fileUrl && item.visibilityProfile" class="attached-file">
              <strong>File Allegato:</strong>
              <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
              <!--<button @click="deleteDocument(item.id)" class="delete-button">Elimina</button>-->
            </div>
          </li>
        </ul>

<!-- Input messaggio -->
<div class="input-container technical-reply-composer">
  <textarea v-model="newResponse.content" placeholder="Inserisci la tua risposta" aria-label="Inserisci la tua risposta" rows="4" class="response-textarea technical-reply-input"></textarea>
  <button @click="submitResponse" :disabled="isSending || !newResponse.content.trim()" class="submit-button-conversation technical-reply-action staff-button-positive">{{ isSending ? 'Invio…' : 'Invia' }}</button>
  <!-- Pulsante per aprire il modale -->
  <button @click="openDeliveryMessagesModal" class="submit-button-conversation technical-reply-action technical-reply-delivery staff-button-neutral">Messaggi di consegna</button>
</div>

  <!-- Riga separata per la select -->
<div class="select-row">
            <p>Seleziona la tipologia della richiesta</p>
  <select aria-label="Tipologia ticket" :value="tipoTicket" :disabled="isSavingTicketType" @change="updateTipoTicket" class="select-tipoticket">
    <option value=""></option>
    <option value="Commerciale">Commerciale</option>
    <option value="Tecnico">Tecnico</option>
    <option value="Ibrido">Ibrido</option>
    <option value="In attesa">In attesa di risposta</option>
  </select>
  <span v-if="isSavingTicketType" class="technical-ticket-category-feedback" role="status">Salvataggio…</span>
  <span v-else-if="ticketTypeError" class="technical-ticket-category-feedback technical-ticket-category-feedback--error" role="alert">{{ ticketTypeError }}</span>
</div>



        <!-- Sezione Documenti -->
        <div class="documents-section">
          <h2>Documenti Allegati</h2>
          <input
            type="file"
            @change="uploadDocument"
            accept="application/pdf, image/jpeg, image/png"
            class="upload-input"
          />
          <ul v-if="filteredDocuments.length">
            <li v-for="(doc, index) in filteredDocuments" :key="'filtered-doc-' + index">
              <a :href="doc.fileUrl" target="_blank">{{ doc.fileName }}</a>
              <span>({{ doc.fileType }})</span>
              <!--<button @click="deleteDocument(doc.id)">Elimina</button>-->
            </li>
          </ul>
          <p v-else class="no-documents">Nessun documento visibile per questo utente.</p>
        </div>
      </div>
    </div>
    <div class="modal" v-if="showOrderModal">
      <div class="modal-content order-modal">
        <span class="close" @click="closeOrderModal">&times;</span>
        <h2>Ultimo ordine</h2>

        <div v-if="orderLoading" class="order-loader">Caricamento…</div>
        <div v-else-if="orderError" class="order-error">{{ orderError }}</div>
        <div v-else-if="orderSummary" class="order-card">
          <div class="order-card__body">
            <div class="order-field">
              <span class="order-field__label">Codice</span>
              <span class="order-field__value">{{ orderSummary.code }}</span>
            </div>
            <div class="order-field">
              <span class="order-field__label">Data</span>
              <span class="order-field__value">{{ orderSummary.date }}</span>
            </div>
            <div class="order-field" v-if="orderSummary.status && orderSummary.status !== '—'">
              <span class="order-field__label">Stato</span>
              <span class="order-field__value">{{ orderSummary.status }}</span>
            </div>
            <div class="order-field">
              <span class="order-field__label">Totale</span>
              <span class="order-field__value">{{ orderSummary.total }}</span>
            </div>
            <div class="order-field order-field--products" v-if="orderSummary.products.length">
              <span class="order-field__label">Prodotti</span>
              <ul class="order-products">
                <li
                  v-for="(product, index) in orderSummary.products"
                  :key="index"
                  :class="productHighlightClass(product)"
                >
                  {{ product }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else class="order-empty">Nessun ordine trovato per questo utente.</div>
      </div>
    </div>
      <!-- Modale per i Messaggi di Consegna -->
  <div class="modal" v-if="showDeliveryMessagesModal">
    <div class="modal-content">
      <span class="close" @click="closeDeliveryMessagesModal">&times;</span>
      <h2>Messaggi di Consegna</h2>
      <div class="message-section" v-for="(message, index) in deliveryMessages" :key="index">
        <h3>{{ message.title }}</h3>
        <pre v-html="truncateMessage(message.content, index)"></pre>
        <button class="staff-button-neutral" v-if="!showFullMessage[index]" @click="toggleFullMessage(index)">Mostra tutto</button>
        <button class="staff-button-neutral" v-else @click="toggleFullMessage(index)">Mostra meno</button>
        <button class="staff-button-neutral" @click="copyMessageToResponse(message.content)">Copia nel messaggio</button>
      </div>
    </div>
  </div>

  <!-- Modale Comunicazione -->
<div v-if="showModal" class="modal">
  <div class="modal-content">
    <h3>Nuova Comunicazione</h3>
    <form @submit.prevent="addComunicazione">
      <label>
        Data e Ora:
        <input type="datetime-local" v-model="newComunicazione.data" required />
      </label>
      <label>
        Tipo:
        <select v-model="newComunicazione.tipo">
          <option value="telefonata">Chiamata</option>
          <option value="prima telefonata">Prima chiamata</option>
          <option value="whatsapp">Whatsapp</option>
          <option value="email">E-mail</option>
          <option value="live">Dal vivo</option>
          <option value="messaggio">Messaggio</option>
          <option value="check confronto">Check di confronto</option>
          <option value="check lavorare">Check lavorare</option>
          <option value="ricontatto intermedio">Ricontatto intermedio</option>
          <option value="ricontatto finale">Ricontatto finale</option>
          <option value="recupero clienti fermi">Recupero clienti fermi</option>
          <option value="altro">Altro</option>
        </select>
      </label>
      <label>
        Urgenza:
        <select v-model="newComunicazione.urgenza">
          <option value="bassa">Bassa</option>
          <option value="media">Media</option>
          <option value="alta">Alta</option>
        </select>
      </label>
      <label>
        Note:
        <input type="text" v-model="newComunicazione.note" />
      </label>
      <label>
        Email Collaboratore/i:
        <input type="text" v-model="newComunicazione.assignedEmail" placeholder="email1@mail.com, email2@mail.com" />
      </label>
      <label>
        Tipo Promemoria:
        <select v-model="newComunicazione.tipoPromemoria">
          <option value="pubblico">Pubblico</option>
          <option value="privato">Privato</option>
        </select>
      </label>
      <div class="modal-actions">
        <button class="staff-button-positive" type="submit">Salva</button>
        <button class="staff-button-cancel" type="button" @click="showModal = false">Annulla</button>
      </div>
    </form>
  </div>
</div>

  </div>
</template>



<script>
import SidebarComponent from '../SidebarComponent.vue';
import { ref, onMounted, onBeforeUnmount, nextTick, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';

import { getFirestore, collection, getDocs, updateDoc, doc, getDoc, query, where, documentId, addDoc, deleteDoc, runTransaction, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import DOMPurify from 'dompurify';
import { useOrderBadge } from '@/composables/useOrderBadge';
import { sendTechnicalTicketMessage, createTechnicalMessageId } from '@/lib/technicalTicketMessages';
import { mergeTechnicalConversation, toDateValue, buildTechnicalMessageKey } from '@/lib/technicalConversation';

export default {
  components: {
    SidebarComponent
  },
  setup() {
    const auth = getAuth();
    const currentUser = ref(null);
    const route = useRoute();
    const router = useRouter();
    const ticketId = computed(() => route.params.ticketId);
    const db = getFirestore();
    const conversations = ref([]);
    const documents = ref([]);
    const tipoTicket = ref('');
    const isSavingTicketType = ref(false);
    const ticketTypeError = ref('');
    const newResponse = ref({
      content: '',
      fileUrl: '',
      fileName: '',
    });
    const isSending = ref(false);
    const user = ref({
      email: '',
      name: '',
      surname: '',
      studio: '',
      uid: '',
    });
    const {
      showOrderModal,
      orderLoading,
      orderError,
      orderSummary,
      openLastOrder,
      closeOrderModal,
      orderBadgeStatus,
      productHighlightClass,
      prefetchUserHighlights,
    } = useOrderBadge();

    const userDetails = ref({});
    const ticketStatus = ref('');
    const ticketType = ref('');
    const isFlagged = ref(false);
    const audioFile = ref(null);
    let authUnsubscribe = null;
    let ticketUnsubscribe = null;
    let documentsUnsubscribe = null;
    let subscriptionGeneration = 0;
    let ticketTypeSnapshotVersion = 0;
    let subscribedUserId = null;
    let pendingMessage = null;
    const showDeliveryMessagesModal = ref(false);
    const fetchedUsers = ref(new Set()); // Mappa degli ID già caricati
    const ticketContainer = ref(null);  // Definisci il riferimento per il contenitore
const showModal = ref(false);
const newComunicazione = ref({
  data: '',
  tipo: '',
  urgenza: '',
  note: '',
  assignedEmail: '',
  tipoPromemoria: 'pubblico',
  fatto: 'da fare'
});

    const orderBadgeClass = computed(() => orderBadgeStatus({
      uid: user.value?.uid,
      email: user.value?.email
    }) || 'neutral');

    const canDeleteMessages = computed(() => {
      const authUser = currentUser.value;
      if (!authUser) return false;
      const email = String(authUser.email || '').toLowerCase();
      return authUser.uid === 'HpMiFyBZnwX6EUf6VR9iCsHkqo82' && email === 'valeriobianconi@gmail.com';
    });

    const handleOpenOrderModal = async () => {
      const email = String(user.value?.email || '').trim();
      if (!email) {
        orderError.value = 'Email non disponibile per questo utente.';
        showOrderModal.value = true;
        return;
      }

      await openLastOrder({
        uid: user.value?.uid,
        email
      });
    };



// Computed property per filtrare i documenti
const filteredDocuments = computed(() => {
  return documents.value.filter(doc => doc.visibilityProfile === true && doc.uploadCategory === "Tecnico");
});

const mergedConversations = computed(() => mergeTechnicalConversation(
  conversations.value,
  filteredDocuments.value
));



   // Per mostrare o meno i messaggi completi
   const showFullMessage = ref([]);


    // Messaggi di consegna
    const deliveryMessages = ref([

    {
  title: 'Messaggio promo FC6',
  content: `Ciaooo☺️, 

volevamo informarti che entro il 30 Novembre hai la straordinaria possibilità di proseguire il tuo percorso con noi ad un prezzo molto vantaggioso: 

6 programmazioni complete e personalizzate a 300€ (invece che 594€)da utilizzare in 8 mesi (c’è anche la possibilità di rateizzare in 4 rate con alma pay)

Se ti va possiamo sentirci qui o programmiamo una chiamata così ti spieghiamo bene come funziona💪🏻

ecco qui il link per procedere se è tutto chiaro: https://bit.ly/3YHzM8V`
},

    
  {
  title: 'Opzione Servizio SENZA PENSIERI',
  content: `Ciao,

Ti informiamo che, entro 10 giorni dalla data odierna, se non lo hai già fatto al momento dell'acquisto, hai la possibilità di rendere il tuo pacchetto più FLESSIBILE e affrontare il tutto con la massima SERENITÀ aggiungendo il servizio "SENZA PENSIERI".

Di seguito ti spieghiamo meglio di cosa si tratta:

Vantaggi inclusi:

• Problemi di salute: Rimborso (con nota di credito) o sospensione del piano con certificato medico.
• Problemi personali certificabili: Rimborso (con nota di credito) o sospensione garantiti.
• Problemi personali a discrezione della direzione: Rimborso (con nota di credito) o sospensione su approvazione.

- Durata: per tutto il tuo pacchetto attivo appena acquistato.

Costo:

• 69 € per Fc 4 ed Fc 6

Importante: Qualsiasi rimborso autorizzato sarà erogato esclusivamente tramite nota di credito, utilizzabile entro 24 mesi dall'emissione per l'acquisto di altri servizi offerti da Fusco.

Contattaci se vuoi attivarlo per ulteriori informazioni, decorsi i 10 giorni dalla consegna del programma non sarà più attivabile.

Cordiali saluti,
Il Team di Fusco Fit`
},


{
    title: 'MESSAGGIO PER RICHIESTA PRENOTAZIONE CONSULENZE TECNICHE: ',
    content: `Ciao ! 

Stiamo preparando il tuo programma, che include una CALL CON UN  NOSTRO PERSONAL TRAINER.

Per fissare l’appuntamento inviaci le tue fasce orarie disponibili e dei giorni preferiti.

La consulenza potrà essere programmata a partire dal giorno  …….

📌 Cose importanti da sapere:

- ⁠Durante la videochiamata potrai anche vedere con il personal trainer, le tecniche di alcuni esercizi: per questo se vorrai farlo, sarà necessario abbigliamento sportivo e spazio a disposizione.

- ⁠Modifiche alla prenotazione: possibili solo entro 24h dall’orario fissato. Oltre questo termine, la mancata partecipazione comporterà la perdita del servizio.

- ⁠Ogni call deve essere erogata nei tempi di utilizzo del programma in consegna: è responsabilità dell’allieva fissare la prenotazione nei tempi previsti, per evitare la scadenza del servizio (noi ti daremo massimo supporto, facciamo un bel lavoro in team 💪🏻).

Attendiamo le tue disponibilità! 😊`
  },


  {
    title: 'MESSAGGIO POST ACQUISTO - PROGRAMMA COMPLETO:',
    content: `Ciaooo

benvenuta in Fusco Fit! 🎉

stiamo per costruire insieme il tuo percorso personalizzato.

Ecco come funziona, passo dopo passo:

📋 Prossimi Step

<strong>1. Scarica la nostra app.</strong>
📲 Fusco Fit Connect (logo nero) → comunicazioni, assistenza, piano alimentare e allenamenti sono tutti nella stessa app.
🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.
📝 Registrati usando la stessa email che ci hai fornito all’acquisto.

<strong>2. Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>
📧 È indispensabile per costruire il tuo piano.
🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.
📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.

<strong>3. Video call con la nutrizionista</strong>
Dopo che il tuo questionario sarà approvato, verrai contattata per fissare l’appuntamento in videocall, se non riesci a rispondere richiamaci appena puoi.
La call è indispensabile per perfezionare il piano alimentare e per ricevere l’allenamento.

<strong>4. Se il tuo piano prevede una call tecnica (servizio plus)</strong>
Riceverai un messaggio in app Fusco Fit Connect (logo nero) per fissare la videocall.
📅 In quel momento ti chiederemo di indicarci le tue fasce orarie di disponibilità per prenotarla, chiaramente dopo la consegna delle programmazioni.

<strong>5. Consegna del programma</strong>
Nei 2 giorni lavorativi successivi alla call con la nutrizionista prepareremo il tuo piano.
📲 La consegna sarà pronta quando riceverai il messaggio di conferma in Fusco Fit Connect (logo nero).
📂 Il piano alimentare sarà nella sezione Alimentazione.
💪 Il programma di allenamento sarà nella sezione Allenamenti della stessa app.

<strong>➡️ Dopo la consegna</strong>
Potrai iniziare subito a seguire il tuo percorso.
Per dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” su app Fusco Fit Connect (logo nero), mentre per dubbi alimentari avrai a disposizione 2 ticket al mese su “assistenza nutrizionale”.

<strong>📌 Nota importante sulle call tecniche</strong>
La call tecnica può essere utilizzata solo all’interno del programma in corso.
Esempio: se hai acquistato 6 programmi → avrai diritto a 1 call per ogni programma.
👉 Una volta terminato il singolo programma, anche la call associata scade se non è stata utilizzata.
Prima di effettuare la videocall segnati ogni dubbio che hai sulla scheda, così li analizzeremo INSIEME❤️

<strong>💪🏻Orari assistenza💪🏻</strong>
Il nostro team è disponibile:
🕘 Lunedì – Venerdì dalle 9:00 alle 19:00
🕙 Sabato dalle 10:00 alle 13:00`
  },






{
    title: 'MESSAGGIO POST ACQUISTO - SOLO ALLENAMENTO:',
    content: `Ciaooo

benvenuta in Fusco Fit! 🎉

stiamo per costruire insieme il tuo percorso personalizzato.

Ecco come funziona, passo dopo passo:

📋 Prossimi Step

<strong>1. Scarica la nostra app.</strong>
📲 Fusco Fit Connect (logo nero) → comunicazioni, assistenza e allenamenti sono tutti nella stessa app.
🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.
📝 Registrati usando la stessa email che ci hai fornito all’acquisto.

<strong>2.Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>
📧 È indispensabile per costruire il tuo piano.
🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.
📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.
	
<strong>3.Se il tuo piano prevede una call tecnica (servizio plus)</strong>
Riceverai un messaggio in app Fusco Fit Connect (logo nero) per fissare la videocall.
📅 In quel momento ti chiederemo di indicarci le tue fasce orarie di disponibilità per prenotarla, chiaramente dopo la consegna delle programmazioni.

<strong>4.Consegna del programma</strong>
📲 La consegna sarà pronta quando riceverai il messaggio di conferma in Fusco Fit Connect (logo nero).
💪 Il tuo programma di allenamento sarà caricato nella sezione Allenamenti della stessa app.

<strong>➡️ Dopo la consegna</strong>
Potrai iniziare subito a seguire il tuo percorso.
Per dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” su app Fusco Fit Connect (logo nero)

<strong>📌 Nota importante sulle call tecniche</strong>
La call tecnica può essere utilizzata solo all’interno del programma in corso.
Esempio: se hai acquistato 6 programmi → avrai diritto a 1 call per ogni programma.
👉 Una volta terminato il singolo programma, anche la call associata scade se non è stata utilizzata.
Prima di effettuare la videocall segnati ogni dubbio che hai sulla scheda, così li analizzeremo INSIEME❤️

<strong>💪🏻Orari assistenza💪🏻</strong>
Il nostro team è disponibile:
🕘 Lunedì – Venerdì dalle 9:00 alle 19:00
🕙 Sabato dalle 10:00 alle 13:00`
  },





{
    title: 'MESSAGGIO POST ACQUISTO - SOLO DIETA:',
    content: `Ciaooooo

benvenuta in Fusco Fit! 🎉

stiamo per costruire insieme il tuo percorso personalizzato.

Ecco come funziona, passo dopo passo:

📋 Prossimi Step

<strong>1. Scarica la nostra app.</strong>
📲 Fusco Fit Connect (logo nero) → utile per le comunicazioni, assistenza e piano alimentare.
🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.
📝 Registrati usando la stessa email che ci hai fornito all’acquisto.

<strong>2. Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>
📧 È indispensabile per costruire il tuo piano.
🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.
📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.

<strong>3. Video call con la nutrizionista</strong>
Dopo che il tuo questionario sarà approvato, verrai contattata per fissare l’appuntamento in videocall, se non riesci a rispondere richiamaci appena puoi.
La call è indispensabile per perfezionare il piano alimentare.
	
<strong>5. Consegna del programma</strong>
Nei 2 giorni lavorativi successivi alla call con la nutrizionista prepareremo il tuo piano.
📲 La consegna sarà pronta quando riceverai il messaggio di conferma in app Fusco Fit Connect (logo nero).
📂 Il tuo piano alimentare sarà nell’app Fusco Fit Connect (logo nero).

<strong>➡️ Dopo la consegna</strong>
Potrai iniziare subito a seguire il tuo percorso.
Per dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” su app Fusco Fit Connect (logo nero), mentre per dubbi alimentari avrai a disposizione 2 ticket al mese su “assistenza nutrizionale”.

<strong>💪🏻Orari assistenza💪🏻</strong>
Il nostro team è disponibile:
🕘 Lunedì – Venerdì dalle 9:00 alle 19:00
🕙 Sabato dalle 10:00 alle 13:00`
  },



{
    title: 'MESSAGGIO CONSEGNA - FC NUOVI',
    content: `Ciao! abbiamo consegnato il tuo programma!  🏋️‍♂️💪😊
    
Nell’app Fusco Fit Connect (logo nero) troverai sia il tuo allenamento, nella sezione “Allenamenti”, sia l’alimentazione, nella sezione “Alimentazione”. Riceverai una notifica quando saranno disponibili!

I carichi che dovrai utilizzare dovranno essere scelti da te cercando di raggiungere la massima intensità con la corretta tecnica e vedrai che poi man mano migliorerai ancora!
Leggi le note e le indicazioni presenti in ogni esercizio.

Controlla se la tua alimentazione contiene una rotazione di carboidrati e seguila attentamente!


Scarica la nostra app.
Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala gratuitamente, se non ne sei in possesso.

Sull’app Fusco Fit Connect (logo nero) puoi ricevere:
- Assistenza dal Team nutrizionale
- Assistenza Tecnica
- Vedere la tua Alimentazione personalizzata
- Puoi creare ricette

Guarda tutto e per qualsiasi cosa siamo qui per te!!   
Continua ad utilizzare Fusco Fit Connect (logo nero) per comunicare con noi.

Aspettiamo anche un tuo feedback dei primi giorni del programma, non tenerti dubbi, partiamo bene insieme! 🏋️‍♂️🥰💪🏻`
  },
  
  {
    title: 'MESSAGGIO CONSEGNA - FC RINNOVI',
    content: `Ciao! abbiamo consegnato il tuo programma! 🏋️‍♂️💪😊

Nell’app Fusco Fit Connect (logo nero) troverai sia il tuo allenamento, nella sezione “Allenamenti”, sia l’alimentazione, nella sezione “Alimentazione”. Riceverai una notifica quando saranno disponibili!

I carichi che dovrai utilizzare dovranno essere scelti da te cercando di raggiungere la massima intensità con la corretta tecnica e vedrai che poi man mano migliorerai ancora!
Leggi le note e le indicazioni presenti in ogni esercizio.

Controlla se la tua alimentazione contiene una rotazione di carboidrati e seguila attentamente!


Sull’app Fusco Fit Connect (logo nero) puoi ricevere:
- Assistenza dal Team nutrizionale
- Assistenza Tecnica
- Vedere la tua Alimentazione personalizzata
- Puoi creare ricette

Guarda tutto e per qualsiasi cosa siamo qui per te!!  
Continua ad utilizzare Fusco Fit Connect (logo nero) per comunicare con noi.

Aspettiamo anche un tuo feedback dei primi giorni del programma, non tenerti dubbi, partiamo bene insieme! 🏋️‍♂️🥰💪🏻`
  },
  {
    title: 'MESSAGGIO CONSEGNA - SOLO WORKOUT - NUOVI',
    content: `Ciao abbiamo consegnato il tuo programma! 🏋️‍♂️💪😊

Nell’app Fusco Fit Connect (logo nero) troverai il tuo allenamento nella sezione “Allenamenti”!

I carichi che dovrai utilizzare dovranno essere scelti da te cercando di raggiungere la massima intensità con la corretta tecnica e vedrai che poi man mano migliorerai ancora!
Leggi le note e le indicazioni presenti in ogni esercizio.

Scarica la nostra app.
Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala gratuitamente, se non ne sei in possesso.

Sull’app Fusco Fit Connect (logo nero) puoi ricevere:
- Assistenza Tecnica
- Puoi creare ricette

Guarda tutto e per qualsiasi cosa siamo qui per te!!
Continua ad utilizzare Fusco Fit Connect (logo nero) per comunicare con noi.

Aspettiamo anche un tuo feedback dei primi giorni del programma, non tenerti dubbi, partiamo bene insieme! 🏋️‍♂️🥰💪🏻`
  },

  {
    title: 'MESSAGGIO CONSEGNA - SOLO WORKOUT - RINNOVI',
    content: `Ciao! abbiamo consegnato il tuo programma! 🏋️‍♂️💪😊

Nell’app Fusco Fit Connect (logo nero) troverai il tuo allenamento nella sezione “Allenamenti”!

I carichi che dovrai utilizzare dovranno essere scelti da te cercando di raggiungere la massima intensità con la corretta tecnica e vedrai che poi man mano migliorerai ancora!
Leggi le note e le indicazioni presenti in ogni esercizio.

Sull’app Fusco Fit Connect (logo nero) puoi ricevere:
- Assistenza Tecnica
- Puoi creare ricette

Guarda tutto e per qualsiasi cosa siamo qui per te!!
Continua ad utilizzare Fusco Fit Connect (logo nero) per comunicare con noi.

Aspettiamo anche un tuo feedback dei primi giorni del programma, non tenerti dubbi, partiamo bene insieme! 🏋️‍♂️🥰💪🏻`
  },
  {
    title: 'MESSAGGIO CONSEGNA - SOLO DIETA NUOVI',
    content: `Ciao abbiamo consegnato il tuo programma! 🏋️‍♂️💪😊

Controlla sulla mail o nell'applicazione Fusco Fit Connect (logo nero), troverai uan notifica per poter visualizzare la tua alimentazione personalizzata!

Controlla se la tua alimentazione contiene una rotazione di carboidrati e seguila attentamente!


Sull’app Fusco Fit Connect (logo nero) puoi ricevere:
- Assistenza dal Team nutrizionale
- Vedere la tua Alimentazione personalizzata
- Puoi creare ricette

Guarda tutto e per qualsiasi cosa siamo qui per te!!
Continua ad utilizzare Fusco Fit Connect (logo nero) per comunicare con noi.

Aspettiamo anche un tuo feedback dei primi giorni del programma, non tenerti dubbi, partiamo bene insieme! 🥰💪🏻`
  },
  {
    title: 'MESSAGGIO CONSEGNA - SOLO DIETA RINNOVI',
    content: `Ciao abbiamo consegnato il tuo programma! 🏋️‍♂️💪😊

    Controlla sulla mail o nell'applicazione Fusco Fit Connect (logo nero), troverai uan notifica per poter visualizzare la tua alimentazione personalizzata!

Controlla se la tua alimentazione contiene una rotazione di carboidrati e seguila attentamente!


Sull’app Fusco Fit Connect (logo nero) puoi ricevere:
- Assistenza dal Team nutrizionale
- Vedere la tua Alimentazione personalizzata
- Puoi creare ricette

Guarda tutto e per qualsiasi cosa siamo qui per te!!
Continua ad utilizzare Fusco Fit Connect (logo nero) per comunicare con noi.

Aspettiamo anche un tuo feedback dei primi giorni del programma, non tenerti dubbi, partiamo bene insieme! 🥰💪🏻`
  }
]);



const addComunicazione = async () => {
  if (!newComunicazione.value.data) {
    alert("Inserisci la data e l'ora.");
    return;
  }

  const parsedDate = new Date(newComunicazione.value.data);
  if (isNaN(parsedDate)) {
    alert("Data non valida");
    return;
  }

  try {
    await addDoc(collection(db, 'comunicazioni'), {
      uid: user.value.uid,
      data: parsedDate,
      tipo: newComunicazione.value.tipo,
      urgenza: newComunicazione.value.urgenza,
      note: newComunicazione.value.note || '',
      assignedEmail: newComunicazione.value.assignedEmail || '',
      tipoPromemoria: newComunicazione.value.tipoPromemoria,
      fatto: newComunicazione.value.fatto,
      visibilita: true
    });

    showModal.value = false;
    newComunicazione.value = {
      data: '',
      tipo: '',
      urgenza: '',
      note: '',
      assignedEmail: '',
      tipoPromemoria: 'pubblico',
      fatto: 'da fare'
    };

    alert("Comunicazione salvata!");
  } catch (error) {
    console.error("Errore nel salvataggio:", error);
    alert("Errore durante il salvataggio.");
  }
};



const updateTipoTicket = async (event) => {
  const activeTicketId = ticketId.value;
  const generation = subscriptionGeneration;
  if (isSavingTicketType.value || !activeTicketId) return;
  const selectedType = event.target.value;
  const previousType = tipoTicket.value;
  const isCurrentTicket = () => generation === subscriptionGeneration && ticketId.value === activeTicketId;
  isSavingTicketType.value = true;
  ticketTypeError.value = '';
  const ticketDocRef = doc(db, 'assistenzatecnica', activeTicketId);
  try {
    await updateDoc(ticketDocRef, { tipoTicket: selectedType });
  } catch (error) {
    console.error('Errore aggiornando tipoTicket:', error);
    if (!isCurrentTicket()) return;
    if (tipoTicket.value === selectedType) tipoTicket.value = previousType;
    const reloadVersion = ticketTypeSnapshotVersion;
    try {
      const snapshot = await getDoc(ticketDocRef);
      if (isCurrentTicket() && reloadVersion === ticketTypeSnapshotVersion && snapshot.exists()) {
        tipoTicket.value = snapshot.data().tipoTicket || '';
      }
    } catch (reloadError) {
      console.error('Errore nel recupero della tipologia del ticket:', reloadError);
    }
    if (isCurrentTicket()) ticketTypeError.value = 'Tipologia non salvata. Riprova.';
  } finally {
    if (isCurrentTicket()) isSavingTicketType.value = false;
  }
};

const toggleTicketFlag = async () => {
  const nextValue = !isFlagged.value;
  try {
    await updateDoc(doc(db, 'assistenzatecnica', ticketId.value), {
      flagged: nextValue
    });
  } catch (error) {
    console.error('Errore durante l\'aggiornamento del flag ticket:', error);
    alert('Errore durante il salvataggio del flag. Riprova.');
  }
};



    // Funzione per aprire il modale
    const openDeliveryMessagesModal = () => {
      showDeliveryMessagesModal.value = true;
    };

    // Funzione per chiudere il modale
    const closeDeliveryMessagesModal = () => {
      showDeliveryMessagesModal.value = false;
    };

    // Funzione per copiare il messaggio nella textarea
    const copyMessageToResponse = (content) => {
  if (newResponse.value && typeof newResponse.value.content === 'string') {
    newResponse.value.content += `\n${content}`; // Aggiunge il messaggio senza sovrascrivere
  } else {
    newResponse.value.content = content; // Se è vuoto, assegna il contenuto
  }

  closeDeliveryMessagesModal(); // Chiude il modale dopo la copia
};



    // Funzione per troncare i messaggi
    const truncateMessage = (message, index) => {
      if (showFullMessage.value[index]) {
        return message;
      } else {
        return message.length > 150 ? message.slice(0, 150) + '...' : message;
      }
    };

    // Funzione per mostrare tutto il messaggio
    const toggleFullMessage = (index) => {
      showFullMessage.value[index] = !showFullMessage.value[index];
    };



    const updateStatus = async (newStatus) => {
      await updateDoc(doc(db, 'assistenzatecnica', ticketId.value), {
        status: newStatus
      });
    };

    const fetchUserDetails = async (userIds) => {
  const validUserIds = userIds.filter(id => id && fetchedUsers.value.has(id) === false); // Assicurati che gli ID siano definiti e non già caricati

  if (validUserIds.length === 0) return;

  const usersCollection = collection(db, 'users');
  const q = query(usersCollection, where(documentId(), 'in', validUserIds));

  try {
    const usersSnapshot = await getDocs(q);
    usersSnapshot.forEach((userDoc) => {
      userDetails.value[userDoc.id] = {
        name: userDoc.data().name,
        surname: userDoc.data().surname,
        email: userDoc.data().email
      };
      fetchedUsers.value.add(userDoc.id); // Aggiungi l'ID alla lista di caricati
    });
  } catch (error) {
    console.error('Errore durante il recupero dei dettagli utente:', error);
  }
};



    const scrollToBottom = () => {
      nextTick(() => {
        const container = ticketContainer.value;
        if (container) container.scrollTop = container.scrollHeight;
      });
    };

    const subscribeDocuments = (userId, generation) => {
      if (documentsUnsubscribe) documentsUnsubscribe();
      documents.value = [];
      documentsUnsubscribe = null;
      if (!userId) return;

      const documentsQuery = query(collection(db, 'documenti'), where('userId', '==', userId));
      documentsUnsubscribe = onSnapshot(documentsQuery, (snapshot) => {
        if (generation !== subscriptionGeneration) return;
        documents.value = snapshot.docs.map((documentSnapshot) => ({
          id: documentSnapshot.id,
          ...documentSnapshot.data()
        }));
      }, (error) => {
        console.error('Errore durante il recupero dei documenti:', error);
      });
    };

    const loadTicketUser = async (userId, generation) => {
      subscribeDocuments(userId, generation);
      if (!userId) return;
      try {
        const userSnapshot = await getDoc(doc(db, 'users', userId));
        if (generation !== subscriptionGeneration || subscribedUserId !== userId) return;
        if (!userSnapshot.exists()) {
          console.error('Dettagli utente non trovati');
          return;
        }
        user.value = { ...userSnapshot.data(), uid: userId };
        if (user.value.email) {
          prefetchUserHighlights([{ uid: userId, email: user.value.email }]);
        }
      } catch (error) {
        console.error('Errore durante il recupero dei dettagli utente:', error);
      }
    };

    const subscribeConversation = (activeTicketId) => {
      const generation = ++subscriptionGeneration;
      if (ticketUnsubscribe) ticketUnsubscribe();
      if (documentsUnsubscribe) documentsUnsubscribe();
      ticketUnsubscribe = null;
      documentsUnsubscribe = null;
      subscribedUserId = null;
      conversations.value = [];
      documents.value = [];
      user.value = {};
      ticketStatus.value = '';
      tipoTicket.value = '';
      isSavingTicketType.value = false;
      ticketTypeError.value = '';
      ticketType.value = '';
      isFlagged.value = false;
      newResponse.value.content = '';
      pendingMessage = null;
      if (!activeTicketId) return;

      ticketUnsubscribe = onSnapshot(doc(db, 'assistenzatecnica', activeTicketId), (snapshot) => {
        if (generation !== subscriptionGeneration) return;
        ticketTypeSnapshotVersion += 1;
        if (!snapshot.exists()) {
          conversations.value = [];
          ticketStatus.value = '';
          tipoTicket.value = '';
          ticketType.value = '';
          isFlagged.value = false;
          if (documentsUnsubscribe) documentsUnsubscribe();
          documentsUnsubscribe = null;
          subscribedUserId = '';
          documents.value = [];
          user.value = {};
          console.error('Ticket non trovato');
          return;
        }
        const data = snapshot.data();
        const previousLength = conversations.value.length;
        conversations.value = Array.isArray(data.conversations) ? data.conversations : [];
        ticketStatus.value = data.status || '';
        tipoTicket.value = data.tipoTicket || '';
        ticketType.value = data.type || '';
        isFlagged.value = !!data.flagged;

        if (subscribedUserId !== (data.userId || '')) {
          subscribedUserId = data.userId || '';
          user.value = {};
          loadTicketUser(data.userId, generation);
        }
        const trainerIds = conversations.value
          .filter(message => message.type === 'Trainer')
          .map(message => message.userId);
        fetchUserDetails([...new Set(trainerIds)]);
        if (previousLength !== conversations.value.length) scrollToBottom();
      }, (error) => {
        console.error('Errore durante il recupero della conversazione:', error);
      });
    };

    // Caricamento documenti
    const uploadDocument = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 10 * 1024 * 1024) {
        alert('Il file supera i 10MB.');
        return;
      }

  // Verifica il tipo di file consentito
  const allowedFileTypes = ["pdf", "jpg", "jpeg", "png"];
  const fileType = allowedFileTypes.find((type) => file.type.includes(type));
  if (!fileType) {
    alert("Formato non supportato. Usa solo PDF, JPG, JPEG o PNG.");
    return;
  }

      const targetUserId = user.value.uid;
      if (!targetUserId) return;
      try {
        const storage = getStorage();
        const filePath = `documenti/${targetUserId}/${file.name}`;
        const fileRef = storageRef(storage, filePath);

        // Caricamento su Firebase Storage
        await uploadBytes(fileRef, file);
        const fileUrl = await getDownloadURL(fileRef);

        // Salvataggio su Firestore
        const docRef = collection(db, 'documenti');
        await addDoc(docRef, {
          userId: targetUserId,
          fileUrl,
          fileName: file.name,
          fileType,
          uploadedAt: serverTimestamp(),
          uploadUser: "Amministrazione", // Campo statico
      visibilityProfile: true, // Nuovo campo statico
      uploadCategory: "Tecnico",

        });

        alert('Documento caricato con successo!');
      } catch (error) {
        console.error('Errore durante il caricamento:', error);
        alert('Errore nel caricamento del documento.');
      }
    };



    // Function to delete document
    const deleteDocument = async (docId) => {
      const docRef = doc(db, 'documents', docId);
      await deleteDoc(docRef);
      documents.value = documents.value.filter(doc => doc.id !== docId);
    };



    const formatDate = (timestamp) => {
      const date = toDateValue(timestamp);
      if (!date) return 'Data non disponibile';
      return `${date.toLocaleDateString('it-IT')} ${date.toLocaleTimeString('it-IT')}`;
    };



    const submitResponse = async () => {
      if (isSending.value) return;
      const content = newResponse.value?.content?.trim();
      if (!content) {
        alert('La risposta non può essere vuota.');
        return;
      }
      const activeTicketId = ticketId.value;
      const draft = newResponse.value.content;
      if (pendingMessage?.ticketId !== activeTicketId || pendingMessage?.content !== content) {
        pendingMessage = { ticketId: activeTicketId, content, messageId: createTechnicalMessageId() };
      }
      const messageRequest = pendingMessage;
      isSending.value = true;
      try {
        await sendTechnicalTicketMessage(messageRequest);
        if (pendingMessage === messageRequest) pendingMessage = null;
        if (ticketId.value === activeTicketId && newResponse.value.content === draft) {
          newResponse.value.content = '';
        }
        scrollToBottom();
      } catch (error) {
        console.error("Errore durante l'invio della risposta:", error);
        alert("Si è verificato un errore durante l'invio della risposta. Riprova.");
      } finally {
        isSending.value = false;
      }
    };

    const deleteMessage = async (item) => {
      if (!canDeleteMessages.value) return;
      if (!item || item.source !== 'conversation') return;
      if (item.type !== 'Trainer' && item.type !== 'Notifica') return;
      const confirmed = confirm("Sei sicuro di voler eliminare questo messaggio?");
      if (!confirmed) return;

      const ticketRef = doc(db, 'assistenzatecnica', ticketId.value);
      try {
        await runTransaction(db, async (transaction) => {
          const ticketSnap = await transaction.get(ticketRef);
          if (!ticketSnap.exists()) {
            throw new Error('Ticket non trovato');
          }

          const data = ticketSnap.data();
          const currentConversations = Array.isArray(data.conversations) ? data.conversations : [];
          const targetKey = buildTechnicalMessageKey(item, item.conversationIndex);

          let targetIndex = -1;
          if (Number.isInteger(item.conversationIndex)) {
            const candidate = currentConversations[item.conversationIndex];
            if (candidate && buildTechnicalMessageKey(candidate, item.conversationIndex) === targetKey) {
              targetIndex = item.conversationIndex;
            }
          }

          if (targetIndex === -1) {
            targetIndex = currentConversations.findIndex((message, index) => {
              return buildTechnicalMessageKey(message, index) === targetKey;
            });
          }

          if (targetIndex === -1) {
            throw new Error('Messaggio non trovato o già eliminato');
          }

          const nextConversations = currentConversations.slice();
          nextConversations.splice(targetIndex, 1);
          const updates = { conversations: nextConversations };
          if (['Aperto', 'Risposto', 'Non Risposto'].includes(data.status)) {
            const lastHuman = nextConversations.slice().reverse()
              .find(message => message.type === 'Richiesta' || message.type === 'Trainer');
            if (lastHuman) updates.status = lastHuman.type === 'Richiesta' ? 'Aperto' : 'Risposto';
          }
          transaction.update(ticketRef, updates);
        });

      } catch (error) {
        console.error('Errore durante l\'eliminazione del messaggio:', error);
        alert('Impossibile eliminare il messaggio. Riprova.');
      }
    };


    const markAsCompleted = async () => {
      try {
        await updateDoc(doc(db, 'assistenzatecnica', ticketId.value), { status: 'Completato' });
      } catch (error) {
        console.error('Error marking ticket as completed:', error);
      }
    };

    const updateTicketType = async (event) => {
      const selectedType = event.target.value;
      try {
        await updateDoc(doc(db, 'assistenzatecnica', ticketId.value), { type: selectedType });
      } catch (error) {
        console.error('Error updating ticket type:', error);
      }
    };

    const convertLinks = (text = '') => {
      if (!text) return '';

      const cleanHref = (raw = '') => {
        let href = raw.trim();
        if (href.startsWith('<')) href = href.slice(1);
        if (href.endsWith('>')) href = href.slice(0, -1);
        // rimuovi punteggiatura finale comune che alcuni client appiccicano
        href = href.replace(/[),.;:]+$/, '');
        if (href && !href.startsWith('http')) href = `http://${href}`;
        return href;
      };

      const markdownPattern = /\[([^\]]+)\]\(\s*<?(https?:\/\/[^\s)<>]+)>?\s*\)/gi;
      let transformed = text.replace(markdownPattern, (_, label, url) => {
        const href = cleanHref(url);
        return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: white; font-weight: bold; text-decoration: underline;">${label}</a>`;
      });

      const urlPattern = /<?\b(https?:\/\/[^\s<>]+|www\.[^\s<>]+)>?/gi;
      transformed = transformed.replace(urlPattern, (match, url, offset, original) => {
        const before = original.slice(0, offset);
        const lastOpen = before.lastIndexOf('<a ');
        const lastClose = before.lastIndexOf('</a>');
        const insideExistingAnchor = lastOpen !== -1 && lastOpen > lastClose;
        if (insideExistingAnchor) return match;

        const href = cleanHref(url);
        return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: white; font-weight: bold; text-decoration: underline;">${url}</a>`;
      });

      return transformed;
    };

    const sanitizeMessageContent = (content) => {
      const contentWithLinks = convertLinks(content || '');
      return DOMPurify.sanitize(contentWithLinks);
    };

    const closeTabAndClearRead = () => {
      window.close();
    };

    const viewUserDetails = (userId) => {
      router.push({ name: 'UserDetails', params: { userId: userId } });
    };



    watch(ticketId, subscribeConversation, { immediate: true });
    watch(() => newResponse.value.content, (content) => {
      if (pendingMessage && pendingMessage.content !== String(content || '').trim()) {
        pendingMessage = null;
      }
    });

    onMounted(() => {
      currentUser.value = auth.currentUser;
      authUnsubscribe = onAuthStateChanged(auth, (user) => {
        currentUser.value = user;
      });
    });



    onBeforeUnmount(() => {
      subscriptionGeneration += 1;
      if (ticketUnsubscribe) ticketUnsubscribe();
      if (documentsUnsubscribe) documentsUnsubscribe();
      if (authUnsubscribe) {
        authUnsubscribe();
      }
    });

    return {
      conversations,
      userDetails,
      user,
      newResponse,
      isSending,
      audioFile,
      submitResponse,
      deleteMessage,
      ticketStatus,
      isFlagged,
      formatDate,
      markAsCompleted,
      updateTicketType,
      ticketType,
      updateStatus,
      sanitizeMessageContent,
      closeTabAndClearRead, 
      viewUserDetails,
      openDeliveryMessagesModal,
      closeDeliveryMessagesModal,
      copyMessageToResponse,
      toggleTicketFlag,
      deliveryMessages,
      showDeliveryMessagesModal,
      truncateMessage,
      toggleFullMessage,
      showFullMessage,
      ticketContainer,
      documents,
      uploadDocument,
      deleteDocument,
      filteredDocuments,
      mergedConversations,
      deleteObject,
      tipoTicket,
      updateTipoTicket,
      isSavingTicketType,
      ticketTypeError,
      orderBadgeClass,
      orderSummary,
      productHighlightClass,
      orderLoading,
      showOrderModal,
      orderError,
      handleOpenOrderModal,
      closeOrderModal,
      showModal,
      newComunicazione,
      addComunicazione,
      canDeleteMessages,


    };
  }
};
</script>

<style scoped>
.technical-ticket-category-feedback {
  font-size: 12px;
  color: #64748b;
}

.technical-ticket-category-feedback--error {
  color: #b91c1c;
}


.modal-content {
  padding: 20px;
  border-radius: 8px;
  width: 570px;

}

.modal-content input[type="datetime-local"] {
  border-radius: 13px;
  background-color: #f1f1f116;
  padding: 14px;
  border: 1px solid #4c4c4c;
  color: rgb(211, 211, 211);
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 15px;
  width: 93%;
  font-size: 1.1rem;
}


.modal-actions { display: flex; gap: 10px; margin-top: 10px; }
.modal-content label { display: block; margin-bottom: 10px; }


.select-row {
  align-items: center;
  justify-content: center;
  display: flex;
  margin-bottom: 57px;
    background-color: #f9f9f9; /* Colore di sfondo chiaro */
      padding: 1.5rem;


}
.select-tipoticket {
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  min-width: 400px;
  max-width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  justify-content: center;
  margin-left: 30px;

}

.documents-section {
  background-color: #f9f9f9; /* Colore di sfondo chiaro */
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.documents-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333; /* Colore del testo */
}

.documents-section input[type="file"] {
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.documents-section input[type="file"]:hover {
  border-color: #007bff; /* Cambia il colore al passaggio del mouse */
}

.documents-section ul {
  list-style-type: none; /* Rimuove i puntini */
  padding: 0;
  margin: 0;
}

.documents-section li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 0.75rem;
  background-color: #fff;
  transition: box-shadow 0.2s ease, background-color 0.2s ease;
}

.documents-section li:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* Aggiunge un'ombra al passaggio del mouse */
  background-color: #f0f8ff; /* Sfondo leggermente colorato */
}

.documents-section a {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  flex: 1; /* Permette al link di occupare più spazio */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.documents-section a:hover {
  text-decoration: underline;
}

.documents-section span {
  font-size: 0.875rem;
  color: #666;
  margin-left: 1rem;
}

.documents-section button {
  background-color: #dc3545; /* Rosso */
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s ease;
}

.documents-section button:hover {
  background-color: #c82333; /* Rosso scuro al passaggio del mouse */
}

.documents-section p {
  font-size: 0.875rem;
  color: #666;
  margin: 1rem 0 0;
  text-align: center;
}

.ticket-container {
  margin-top: 177px;
}
.documents-section {
  margin-top: 10px;
}

.submit-button-conversation {
  padding: 10px 40px;
}
.response-textarea {
  flex: 0 0 65%;
}


.ticket-container {
  max-height: 700px; /* Imposta un'altezza fissa */
  overflow-y: auto;  /* Abilita lo scroll verticale */
  margin-top: 10px !important;
}


.content-container {
  margin-top: 0px; /* Allinea il contenuto al blocco sticky */
}

/* Titolo-card come fixed, ma non sopra il contenuto */
.titolo-card {
  position: sticky;
  top: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 22px 26px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(2px);
}

.title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.title-actions {
  display: flex;
  gap: 10px;
}

.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: all 0.2s ease;
  cursor: pointer;
}

.icon-button:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #312e81;
}

.icon-button--flagged {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #ffffff;
}

.icon-button--flagged:hover {
  background: #d97706;
  border-color: #d97706;
  color: #ffffff;
}

.icon-button--order {
  border-color: rgba(148, 163, 184, 0.45);
  background: #f7f9fc;
  color: #475569;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.icon-button--order:hover {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #4338ca;
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.12);
}

.icon-button--order-green {
  border: none;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(34, 197, 94, 0.32);
}

.icon-button--order-green:hover {
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  border: none;
  box-shadow: 0 18px 40px rgba(34, 197, 94, 0.36);
}

.icon-button--order-orange {
  border: none;
  background: linear-gradient(120deg, #f97316, #ea580c);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(249, 115, 22, 0.28);
}

.icon-button--order-orange:hover {
  background: linear-gradient(120deg, #f97316, #ea580c);
  color: #ffffff;
  border: none;
  box-shadow: 0 18px 40px rgba(234, 88, 12, 0.32);
}

.icon-button--order-neutral {
  background: #f8fafc;
  border-color: rgba(148, 163, 184, 0.45);
  color: #475569;
}

.summary-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.summary-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}

.summary-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
}

/* Input-container con margini ridotti grazie al layout migliore */
.input-container {
  margin-top: 10px; /* Ridotto per allinearsi meglio al nuovo layout */
  margin-bottom: 37px;
}

.message-content {
  white-space: pre-wrap;
}

.message-content a {
  color: white;
  font-weight: bold;
  text-decoration: underline;
}

.message-content a:visited {
  color: white; /* Assicurati che il colore sia bianco anche per i link visitati */
}

.order-modal {
  width: min(360px, 92vw);
  padding: 30px 32px 34px;
  background: linear-gradient(160deg, #2f3543 0%, #1f262f 100%);
  border-radius: 26px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.45);
  color: #f8fafc;
  text-align: center;
}

.order-modal h2 {
  margin: 0 auto 20px;
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.order-loader,
.order-empty,
.order-error {
  font-size: 0.95rem;
  color: #e2e8f0;
  margin: 24px 0 0;
}

.order-error {
  color: #fca5a5;
}

.order-card {
  background: linear-gradient(165deg, #f8fafc 0%, #e5ebf6 100%);
  border-radius: 22px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  padding: 22px 24px;
  color: #0f172a;
}

.order-card__body {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.order-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
}

.order-field__label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4b5563;
}

.order-field__value {
  font-size: 1.02rem;
  font-weight: 700;
  color: #111827;
}

.order-field--products {
  border-top: 1px solid rgba(79, 70, 229, 0.16);
  padding-top: 16px;
  width: 100%;
}

.order-products {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  color: #1f2937;
  font-weight: 600;
}

.order-products li {
  padding: 6px 0;
  border-radius: 10px;
  text-align: center;
}

.order-product--green {
  color: #166534;
}

.order-product--orange {
  color: #9a3412;
}

.order-product--neutral {
  color: #1f2937;
}

/* Aggiungi stile per il pulsante di eliminazione */
.delete-button {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
}

.delete-button:hover {
  text-decoration: underline;
}





.close {
  top: 35px;
  right: 40px;
  font-size: 30px;
  cursor: pointer;
}

.order-modal .close {
  color: #e2e8f0;
  top: 18px;
  right: 24px;
}

/* Colore del testo del contenuto */
.message-section pre {
  background-color: #f0f0f0;
  padding: 10px;
  white-space: pre-wrap;
  color: #333; /* Cambiato da bianco a grigio scuro per migliorare la leggibilità */
}



/* Stile del pulsante per copiare */
.message-section button {
  margin-top: 10px;
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
}

.message-section button:hover {
  background-color: #218838;
}

.titolo-card h1 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 0px;
}


/* Solo il compositore tecnico mobile usa queste classi dedicate. */
@media (max-width: 768px) {
  .technical-reply-composer {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
    gap: 12px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    margin-top: 16px;
    margin-bottom: 28px;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    background: #f1f5f9;
  }

  .technical-reply-composer .technical-reply-input {
    grid-column: 1 / -1;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    min-height: 152px;
    height: auto;
    box-sizing: border-box;
    margin: 0;
    padding: 12px;
    border: 1px solid #cbd5e1;
    border-radius: 12px;
    background: #ffffff;
    color: #0f172a;
    font-size: 16px;
    line-height: 1.5;
    resize: vertical;
  }

  .technical-reply-composer .technical-reply-input::placeholder {
    color: #64748b;
    opacity: 1;
  }

  .technical-reply-composer .technical-reply-action {
    width: 100%;
    min-width: 0;
    min-height: 48px;
    height: auto;
    box-sizing: border-box;
    margin: 0;
    padding: 12px 8px;
    border: 1px solid #15803d;
    border-radius: 12px;
    background: #15803d;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .technical-reply-composer .technical-reply-delivery {
    border-color: #cbd5e1;
    background: #e2e8f0;
    color: #0f172a;
  }

  .technical-reply-composer .technical-reply-input:focus-visible,
  .technical-reply-composer .technical-reply-action:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
}
</style>
.titolo-card h1 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f172a;
}
